import { render, staticRenderFns } from "./InfoCard.vue?vue&type=template&id=3976e939&scoped=true"
import script from "./InfoCard.vue?vue&type=script&lang=js"
export * from "./InfoCard.vue?vue&type=script&lang=js"
import style0 from "./InfoCard.vue?vue&type=style&index=0&id=3976e939&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3976e939",
  null
  
)

export default component.exports